import Input from "../../Input"

const OnClientsChannel = ({ values, serverData }) => {
    return (
        <div className="mx-14 h-full font-sans">
            <h6 className="flex justify-center">چنل کلاینت های انلاین</h6>
            <div className="">
                <Input
                    type="number"
                    label="ایدی چنل *"
                    name={`onClientsChannel-id`}
                    options={serverData?.channelList}
                    placeholder="ChannelID"
                    autoComplete="off"
                    defaultValue={values?.id}
                    dir="ltr"
                />
            </div>
            <div className="">
                <Input
                    type="text"
                    name={`onClientsChannel-ignoreSgList`}
                    options={serverData?.sgList}
                    multi={true}
                    label="ایدی رنک ها برای چشم پوشی:(با , میتوانید چند تا رنک وارد کنید)"
                    placeholder="مثال: 1,2,3"
                    autoComplete="off"
                    defaultValue={values?.ignoreSgList}
                    dir="ltr"
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    label="فرمت *"
                    name={`onClientsChannel-format`}
                    placeholder="format"
                    autoComplete="off"
                    defaultValue={values?.format}
                    dir="ltr"
                />
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr">
                    <div>%c: تعداد</div>
                </div>
            </div>
        </div>
    )
}

export default OnClientsChannel
